var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000488281,
    width: 17.9996,
    height: 17.9996,
    rx: 8.99979,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00024 1.5C13.1422 1.50011 16.5002 4.85806 16.5002 9C16.5001 13.1418 13.1421 16.4999 9.00024 16.5C4.85832 16.5 1.50037 13.1419 1.50024 9C1.50024 4.85799 4.85824 1.5 9.00024 1.5ZM2.94849 9.70312C3.29732 12.7373 5.87265 15.0938 9.00024 15.0938C10.7334 15.0937 12.2959 14.3685 13.4055 13.207H8.93188C6.84819 13.207 5.11926 11.6916 4.78442 9.70312H2.94849ZM6.22388 9.70312C6.53629 10.9092 7.62819 11.8007 8.93188 11.8008H14.4114C14.744 11.1595 14.9659 10.4523 15.052 9.70313L6.22388 9.70312ZM14.4075 6.18945L8.93188 6.19824C7.62796 6.19832 6.53607 7.0905 6.22388 8.29688L15.053 8.29688C14.9665 7.54399 14.7427 6.83323 14.4075 6.18945ZM9.00024 2.90625C5.87245 2.90625 3.29608 5.26246 2.94751 8.29688H4.78442C5.11896 6.30816 6.84814 4.79226 8.93188 4.79199L13.3987 4.78516C12.2895 3.62788 10.7298 2.90631 9.00024 2.90625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.be67101e890930e3992a7e7a674c3b6a.svg";
export { ForwardRef as ReactComponent };